export enum KnownProcessType {
    PME = 1,
    PMEDescription = 'PME',
    PMQ = 2,
    PMQDescription = 'PMQ',
    _360 = 4,
    _360Description = '360',
    Combined = 8,
    CombinedDescription = 'Combined'
}